<template>
  <div class="integral">
    <div class="div-top">
      <div class="txt1" @click="handleClickRule">积分规则</div>
      <div class="txt2">积分余额</div>
      <div class="txt3">{{ integral > 0 ? integral : 0 }}</div>
    </div>
    <div class="flex-nav">
      <div class="nav-txt1" :class="curIndex === 0 ? 'cur' : ''" @click="handleClickFlex(0)">
        <div class="txt">
          积分获得
          <img src="@/assets/images/training/img(23).png" @click.stop="handleTip" class="icon-tip" alt="">
        </div>
        <img v-if="curIndex === 0" src="@/assets/images/training/img(6).png" class="icon-cur" alt="">
      </div>
      <div class="nav-txt1" :class="curIndex === 1 ? 'cur' : ''" @click="handleClickFlex(1)">
        积分消费
        <img v-if="curIndex === 1" src="@/assets/images/training/img(6).png" class="icon-cur" alt="">
      </div>
    </div>
    <van-list v-model="loading" :finished="finished" :finished-text="finishText" @load="handleGetUserCost">
      <div class="inter-list" v-if="list.length > 0">
        <div class="inter-item" v-for="(item, index) in list" :key="index">
          <img v-if="`${item.contentType ? item.contentType : item.type}` === '1'" src="@/assets/images/training/img(24).png" class="item-cover"
            alt="">
          <img v-if="`${item.contentType ? item.contentType : item.type}` === '2'" src="@/assets/images/training/img(25).png" class="item-cover"
            alt="">
          <img v-if="`${item.contentType ? item.contentType : item.type}` === '3'" src="@/assets/images/training/img(26).png" class="item-cover"
            alt="">
          <img v-if="`${item.contentType ? item.contentType : item.type}` === '4'" src="@/assets/images/training/img(27).png" class="item-cover"
            alt="">
          <img v-if="`${item.contentType ? item.contentType : item.type}` === '5'" src="@/assets/images/training/img(28).png" class="item-cover"
            alt="">
          <img v-if="`${item.contentType ? item.contentType : item.type}` === '6'" src="@/assets/images/training/img(29).png" class="item-cover"
            alt="">
          <img v-if="`${item.contentType ? item.contentType : item.type}` === '8'" src="@/assets/images/training/contest.png" class="item-cover"
               alt="">
          <template v-if="curIndex === 0">
            <div class="item-txt">{{ item && item.content }}</div>
            <div class="item-txt2">{{ item && item.cost }}积分</div>
          </template>
          <template v-if="curIndex === 1">
            <div class="item-txt">{{ item.unlockContent }}</div>
            <div class="item-txt2" v-if="item.unlockCost > 0">{{ item.unlockCost }}积分</div>
            <div class="item-txt2" v-else>权益兑换</div>
          </template>
        </div>
      </div>
      <div class="empty-block" v-else-if="isNone">
        <img src="@/assets/images/zone/img18.png" class="empty-img" alt="" />
        <div class="empty-txt">暂无内容</div>
      </div>
    </van-list>
  </div>
</template>
<script>
import { getUserCostTotal, getUserCost, getUserUseCost } from '../../api/person'
import withRouteTracking from '@/utils/withRouteTracking'
const UserProfile = {
  data () {
    return {
      integral: 0,
      list: [],
      loading: false,
      finished: false,
      pageObj: {
        pageNo: 1,
        pageSize: 10
      },
      isNone: false,
      finishText: '没有更多了',
      curIndex: 0
    }
  },
  computed: {
    userInfo () {
      return this.$store.getters.userInfo
    }
  },
  mounted () {
    getUserCostTotal({
      userId: this.userInfo.id
    }).then(res => {
      this.integral = res.data
    })
  },
  methods: {
    handleGetUserCost () {
      if (this.curIndex === 0) {
        let params = {
          pageNum: this.pageObj.pageNo,
          pageSize: this.pageObj.pageSize,
          userId: this.userInfo.id
        }
        getUserCost(params).then(res => {
          this.$toast.clear()
          if (res) {
            if (res.code !== 0 || !res.data || !res.data.list) {
              this.loading = false
              this.finished = true
              return false
            }

            this.loading = false
            if (res.data.list.length < this.pageObj.pageSize) {
              this.finished = true
            }
            if (res.code === 0 && res.data.list) {
              this.list = this.list.concat(res.data.list)
            }
            this.pageObj.pageNo++
            if (this.list.length === 0) {
              this.isNone = true
              this.finishText = ''
            }
          }
        }).catch(err => {
          this.$toast.clear()
          console.log('err:', err)
        })
      } else if (this.curIndex === 1) {
        let params = {
          pageNum: this.pageObj.pageNo,
          pageSize: this.pageObj.pageSize,
          userId: this.userInfo.id
        }
        getUserUseCost(params).then(res => {
          this.$toast.clear()
          if (res) {
            if (res.code !== 0 || !res.data || !res.data.list) {
              this.loading = false
              this.finished = true
              return false
            }

            this.loading = false
            if (res.data.list.length < this.pageObj.pageSize) {
              this.finished = true
            }
            if (res.code === 0 && res.data.list) {
              this.list = this.list.concat(res.data.list)
            }
            this.pageObj.pageNo++
            if (this.list.length === 0) {
              this.isNone = true
              this.finishText = ''
            }
          }
        }).catch(err => {
          this.$toast.clear()
          console.log('err:', err)
        })
      }
    },
    handleClickFlex (index) {
      if (this.curIndex === index) return
      this.curIndex = index
      this.list = []
      this.loading = false
      this.finished = false
      this.pageObj = {
        pageNo: 1,
        pageSize: 10
      }
      this.isNone = false
      // this.handleGetUserCost()
    },
    handleTip () {
      this.$toast('每日8点刷新上一日积分获得数据')
    },
    handleClickRule () {
      this.$router.push({
        path: '/integralRule'
      })
    }
  }
}
export default withRouteTracking(UserProfile)
</script>
<style lang="less" scoped>
.integral {
  position: relative;
  min-height: 100vh;
  background: #F9F8F7;
  padding: 24px 20px;
  box-sizing: border-box;

  .bg-img {
    width: 100%;
    position: absolute;
    top: 0;
    left: 0;
  }

  .div-top {
    position: relative;
    border-radius: 12px;
    background: #fff;
    padding-top: 8px;
    padding-left: 26px;
    padding-right: 11px;
    height: 120px;
    box-sizing: border-box;
    margin-bottom: 8px;

    .txt1 {
      text-align: right;
      font-size: 14px;
      color: #6C717B;
      line-height: 24px;
    }

    .txt2 {
      text-align: left;
      font-size: 14px;
      color: #6C717B;
      line-height: 24px;
    }

    .txt3 {
      font-size: 32px;
      color: #EB1700;
      line-height: 32px;
    }
  }

  .flex-nav {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 46px;
    background-color: #fff;
    border-radius: 12px 12px 0 0;
    position: relative;

    .nav-txt1 {
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 14px;
      color: #000000;
      flex: 1;
      position: relative;
      padding-bottom: 4px;

      &.cur {
        color: #EB1700;

        .txt {
          color: #EB1700;
        }
      }

      .txt {
        position: relative;
      }

      .icon-tip {
        position: absolute;
        right: -14px;
        width: 10px;
        top: 50%;
        transform: translateY(-50%);
      }

      .icon-cur {
        position: absolute;
        width: 23px;
        bottom: -7px;
        left: 50%;
        transform: translateX(-50%);
      }
    }
  }

  .inter-list {
    margin-top: 2px;
    background-color: #fff;
    min-height: 60vh;
    border-radius: 0 0 12px 12px;
    position: relative;

    .inter-item {
      display: flex;
      align-items: center;
      border-bottom: 1px solid #F2F7FA;
      padding: 13px;
      box-sizing: border-box;

      .item-cover {
        width: 28px;
        height: 28px;
        margin-right: 9px;
      }

      .item-txt {
        font-size: 14px;
        color: #000000;
        font-weight: 500;
        flex: 1;
      }

      .item-txt2 {
        font-size: 14px;
        font-weight: 500;
        color: #EB1700;
      }
    }
  }
}
.empty-block {
  padding-top: 114px;
  box-sizing: border-box;
  .empty-img {
    width: 185px;
    display: block;
    position: relative;
    left: 50%;
    transform: translateX(-50%);
    margin-bottom: 10px;
  }
  .empty-txt {
    text-align: center;
    font-size: 14px;
    color: rgba(0,0,0,0.5);
    line-height: 20px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/person/integral.vue